import { render, staticRenderFns } from "./ShopOwnerMenu.vue?vue&type=template&id=5801cb2c&scoped=true&"
import script from "./ShopOwnerMenu.vue?vue&type=script&lang=ts&"
export * from "./ShopOwnerMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ShopOwnerMenu.vue?vue&type=style&index=0&id=5801cb2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5801cb2c",
  null
  
)

export default component.exports